import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-434">
      <div className="container mx-auto px-4" data-id="element-435">
        <FadeIn data-id="element-436">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-437">
            <div className="flex flex-col items-center text-center px-4" data-id="element-438">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-439">
                🏭
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-440">
                +130
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-441">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-442">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-443">
                📚
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-444">
                8
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-445">
                Módulos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-446">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-447">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-448">
                3
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-449">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-450">
              <div className="flex gap-1 mb-3" data-id="element-451">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-lg" data-id="element-452">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-453">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-454">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-455">
          <FadeIn delay={0.1} data-id="element-456">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-457">
              <div className="flex gap-1 mb-4" data-id="element-458">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-459">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-460">
                "Armé el primer trabajo con el sistema y no tuve que medir dos
                veces. Las fórmulas de descuento me cambiaron la vida."
              </p>
              <div className="flex items-center gap-3" data-id="element-461">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-462">
                  F
                </div>
                <div data-id="element-463">
                  <p className="font-bold text-white text-sm" data-id="element-464">Federico M.</p>
                  <p className="text-xs text-gray-500" data-id="element-465">Mar del Plata</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-466">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-467">
              <div className="flex gap-1 mb-4" data-id="element-468">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-469">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-470">
                "Le pasé las planillas a mi ayudante y trabajó solo toda la
                semana. Por primera vez no tuve que estar encima de todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-471">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-472">
                  G
                </div>
                <div data-id="element-473">
                  <p className="font-bold text-white text-sm" data-id="element-474">Gonzalo S.</p>
                  <p className="text-xs text-gray-500" data-id="element-475">
                    Bahía Blanca · Instalador de Mamparas
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-476">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-477">
              <div className="flex gap-1 mb-4" data-id="element-478">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-sm" data-id="element-479">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-480">
                "El Módulo 8 de presupuestos me hizo darme cuenta que estaba
                trabajando sin ganancia real. Ahora cobro lo que corresponde."
              </p>
              <div className="flex items-center gap-3" data-id="element-481">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-482">
                  H
                </div>
                <div data-id="element-483">
                  <p className="font-bold text-white text-sm" data-id="element-484">Hernán L.</p>
                  <p className="text-xs text-gray-500" data-id="element-485">San Juan</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}